import {
  Input as MatchaInput,
  type InputProps,
  Intent,
} from '@axieinfinity/matcha'
import { memo } from 'react'

export type TInput = InputProps & {
  error?: string
}

const InputComponent: React.FC<TInput> = props => {
  return (
    <MatchaInput
      {...props}
      intent={props.error ? Intent.Danger : props.intent}
      caption={props.error}
    />
  )
}
export const Input = memo(InputComponent)
